<script>
/**
 * ****************************************************************************
 * @description     :   Component for popup search １次会社通知先
 * @created at      :   2022/06/02
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import { mapActions } from 'vuex';
import template from './template.html';
import repository from '@/utils/repository';

/**
 * Define component chat for popup search work request contents
 */

var ra006400v = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object
    },
    data() {
        return {
            resultSearch: []
        };
    },
    computed: {
        initObject() {
            return this.initData;
        }
    },
    mounted() {
        this.doSearch();
    },
    watch: {
        initData() {
            this.doSearch();
        }
    },
    methods: {
        ...mapActions('app', ['showHeaderError', 'hideHeaderError']),
        doSearch: function () {
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
            repository
                .get(`inquiry/ra006400v`, {
                    params: {
                        bukkenno: this.initObject.bukken_no,
                        ichiji_cd: this.initObject.ichiji_no
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const length = data.Data.length;
                        const emails = this.initObject.email
                            ? this.initObject.email.split(';')
                            : [];
                        for (let i = 0; i < length; i++) {
                            if (emails.indexOf(data.Data[i].email) >= 0) {
                                data.Data[i].select_flg = 1;
                            } else {
                                data.Data[i].select_flg = 0;
                            }
                        }
                        this.resultSearch = data.Data;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        checked(i) {
            return this.resultSearch[i].select_flg == 1;
        },
        onChange(i) {
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
            this.resultSearch[i].select_flg =
                this.resultSearch[i].select_flg == 1 ? 0 : 1;
        },
        getChecked() {
            const result = [];
            const length = this.resultSearch.length;
            for (let i = 0; i < length; i++) {
                if (this.resultSearch[i].select_flg == 1) {
                    result.push(this.resultSearch[i]);
                }
            }
            return result;
        },
        selectData() {
            const data = this.getChecked();
            if (data.length == 0) {
                this.showHeaderError(['明細行を１行以上選択してください。']);
                return;
            }
            if (
                this.resultSearch &&
                this.resultSearch.length > 0 &&
                this.onSelected
            ) {
                this.onSelected(data, true);
            }
            this.$refs.close.click();
        }
    }
};
export default ra006400v;
</script>
